export default __webpack_public_path__ + "static/media/logoCLat.b9565169.svg";